import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { CalendarGrid } from '../../CalendarGrid'
import { NotificationInline } from '../../Notification'
import { CALENDAR_TASKS_FILTERS } from '../Calendar.constants'
import { CalendarContext } from '../Calendar.context'
import { CalendarDayPopoverActions } from '../CalendarDayPopoverActions'
import { CalendarItemCard } from '../CalendarItemCard'
import { CalendarItemStatus } from '../CalendarItemStatus'

import { QA_NAME_CALENDAR_NO_TASK_TYPES } from './CalendarView.constants'
import { useCalendarView } from './CalendarView.hooks'
import {
  getCalendarViewBodyMessage,
  getCalendarViewNoTaskTypesNoticeProps,
  getHasCalendarViewNoTaskTypesNotice,
} from './CalendarView.utils'

import * as styles from './CalendarView.module.css'

function CalendarView({
  className = styles.CalendarView,
  filters = CALENDAR_TASKS_FILTERS,
  initialMode,
  modes,
  onChangeMode,
}) {
  const { t } = useTranslation()

  const {
    calendar,
    canOpenSettings,
    handleChangeTaskStatus,
    handleClickItem,
    handleMoveItem,
    handleOpenRelieveDay,
    handleOpenSettings,
    handleOpenTask,
    handleStartAction,
    modal,
  } = useCalendarView({ filters, initialMode, modes, onChangeMode })

  return (
    <CalendarContext
      value={{
        onChangeTaskStatus: handleChangeTaskStatus,
        onOpenRelieveDay: handleOpenRelieveDay,
        onOpenTask: handleOpenTask,
      }}
    >
      <div className={className} onClickCapture={handleStartAction}>
        {getHasCalendarViewNoTaskTypesNotice({ calendar, filters }) ? (
          <NotificationInline
            {...getCalendarViewNoTaskTypesNoticeProps({
              canOpenSettings,
              t,
              onOpenSettings: handleOpenSettings,
            })}
            qaName={QA_NAME_CALENDAR_NO_TASK_TYPES}
            type={NOTIFICATION_TYPE.info}
          />
        ) : null}
        <CalendarGrid
          DayPopoverActions={CalendarDayPopoverActions}
          ItemCard={CalendarItemCard}
          ItemStatus={CalendarItemStatus}
          bodyMessage={getCalendarViewBodyMessage({
            calendar,
            canOpenSettings,
            filters,
            t,
            onOpenSettings: handleOpenSettings,
          })}
          calendar={calendar}
          isLoading={calendar.isLoading || calendar.isRefetching}
          onClickItem={handleClickItem}
          onMoveItem={handleMoveItem}
        />
      </div>
      {modal}
    </CalendarContext>
  )
}

export default CalendarView
